__turbopack_context__.v({
  "activeTabFaq": "FaqSectionWithoutCatergory-module-scss-module__cc13yG__activeTabFaq",
  "backChange": "FaqSectionWithoutCatergory-module-scss-module__cc13yG__backChange",
  "deactiveTabFaq": "FaqSectionWithoutCatergory-module-scss-module__cc13yG__deactiveTabFaq",
  "faqAns": "FaqSectionWithoutCatergory-module-scss-module__cc13yG__faqAns",
  "faqAnsCk": "FaqSectionWithoutCatergory-module-scss-module__cc13yG__faqAnsCk",
  "faqQue": "FaqSectionWithoutCatergory-module-scss-module__cc13yG__faqQue",
  "faqQues": "FaqSectionWithoutCatergory-module-scss-module__cc13yG__faqQues",
  "faqblock": "FaqSectionWithoutCatergory-module-scss-module__cc13yG__faqblock",
  "faqtab": "FaqSectionWithoutCatergory-module-scss-module__cc13yG__faqtab",
  "faqtabQes": "FaqSectionWithoutCatergory-module-scss-module__cc13yG__faqtabQes",
  "homeHeadingFaq": "FaqSectionWithoutCatergory-module-scss-module__cc13yG__homeHeadingFaq",
  "icon": "FaqSectionWithoutCatergory-module-scss-module__cc13yG__icon",
  "jobRoleAns": "FaqSectionWithoutCatergory-module-scss-module__cc13yG__jobRoleAns",
  "jobRoleBlock": "FaqSectionWithoutCatergory-module-scss-module__cc13yG__jobRoleBlock",
  "jobRoleHeading": "FaqSectionWithoutCatergory-module-scss-module__cc13yG__jobRoleHeading",
  "jobRoleQue": "FaqSectionWithoutCatergory-module-scss-module__cc13yG__jobRoleQue",
  "leadTheFutureContainerInner": "FaqSectionWithoutCatergory-module-scss-module__cc13yG__leadTheFutureContainerInner",
  "mainHeadingFaq": "FaqSectionWithoutCatergory-module-scss-module__cc13yG__mainHeadingFaq",
  "tabBtnFaq": "FaqSectionWithoutCatergory-module-scss-module__cc13yG__tabBtnFaq",
});
